module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-download"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/download@2x.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d46b853","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/IconDownload.vue
// module id = 354
// module chunks = 0